module.exports = __webpack_public_path__ + "static/img/torso10.7ba4a8e9.jpg";